<section class="content-header">

    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Add Food Safety On Wheels </h1>
            </div>

        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</section>
<!-- /.content-header -->
<section class="content">
    <!-- Default box -->
    <div class="container-fluid">


        <div class="card" style="width: 100%;">

            <div class="card-body">

                <!--tab start-->
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link active" id="home-tab" (click)="clickTab(1)" [ngClass]="{active:tab==1}">Basic
                            Detail</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="home-tab" (click)="clickTab(2)" [ngClass]="{active:tab==2}">Manpower</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="profile-tab" (click)="clickTab(3)"
                            [ngClass]="{active:tab==3}">Equipment</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="messages-tab" (click)="clickTab(4)" [ngClass]="{active:tab==4}">Test
                            Capability</a>
                    </li>

                </ul>

                <div class="tab-content">
                    <div class="tab-pane" *ngIf="tab==1" [ngClass]="{active:tab==1}">
                        <h5 class="card-header">Basic Details</h5>
                        <form [formGroup]="addVehicleForm" (ngSubmit)="onaddVehicleSubmit()">
                            <!-- <h5 *ngIf="success">Your form is valid!</h5> -->
                            <div class="form-group">
                                <label>
                                    State:<span style="color:red;">*</span>
                                    <select [(ngModel)]="selectedState" style="width:600px" formControlName="stateCode"
                                        class="form-control" (change)="getDistrict()">
                                        <option [ngValue]="" selected disabled>Select State</option>
                                        <option *ngFor="let state of StateRecord" [ngValue]="state.stateCode">
                                            {{state.stateName}}</option>
                                    </select>
                                    <div *ngIf="submitted && addVehicleForm.controls.stateCode.errors" class="error">
                                        <div *ngIf="addVehicleForm.controls.stateCode.errors.required"
                                            style="color:red">State
                                            is required</div>
                                    </div>
                                </label>
                            </div>

                            <div class="form-group">
                                <label>
                                District:<span style="color:red;">*</span>
                                <select [(ngModel)]="selectedDistrict" style="width:600px" formControlName="districtCode" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.districtCode.errors }">
                                    <option [ngValue]="" disabled>Select District</option>
                                    <option *ngFor="let district of districtRecord" [ngValue]="district.districtCode" >
                                        {{district.districtName}}</option>
                                </select>
                            </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Vehicle No. :<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="vehicleNo"
                                        class="form-control" (keypress)="($event.charCode >= 48 && $event.charCode < 58)||($event.charCode > 64 && $event.charCode < 91) || ($event.charCode > 96 && $event.charCode < 123)"
                                        [ngClass]="{ 'is-invalid': submitted && f.vehicleNo.errors }" placeholder="Enter vehicle no. of minimum length 8 and maximum length 30">
                                    <div *ngIf="submitted && f.vehicleNo.errors" class="invalid-feedback">
                                        <div *ngIf="f.vehicleNo.errors.required">Vehicle No. is required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Chasis No. :<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="chasisNo"
                                        class="form-control" placeholder="Chasis No. is required"
                                        [ngClass]="{ 'is-invalid': submitted && f.vehicleNo.errors }">
                                    <div *ngIf="submitted && addVehicleForm.controls.chasisNo.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="addVehicleForm.controls.chasisNo.errors.required" style="color:red">
                                            Chasis No. is required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    MFTL Station :
                                    <input type="text" style="width:600px" formControlName="city" class="form-control"  placeholder="Enter MFTL Station here">

                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Email Id. :<span style="color:red;">*</span>
                                    <input type="email" style="width:600px" formControlName="emailId"
                                        class="form-control" placeholder="Enter valid emailId ">
                                    <div *ngIf="submitted && addVehicleForm.controls.emailId.errors" class="error">
                                        <div *ngIf="addVehicleForm.controls.emailId.errors.required" style="color:red">
                                            Email Id is required</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Mobile No. :<span style="color:red;">*</span>
                                    <input type="text" style="width:600px" formControlName="mobileNo"
                                        class="form-control" maxlength="10" placeholder="Enter mobile number of 10 digits" (keypress)="($event.charCode >= 48 && $event.charCode < 58)">
                                    <div *ngIf="submitted && addVehicleForm.controls.mobileNo.errors && addVehicleForm.controls.mobileNo.invalid"
                                        class="error">
                                        <div *ngIf="addVehicleForm.controls.mobileNo.errors.required" style="color:red">
                                            Mobile No. is required</div>
                                        <div *ngIf="addVehicleForm.controls.mobileNo.errors.pattern">Please, Enter 10
                                            digit Mobile Number.</div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                    Driver Allocated :<span style="color:red;">*</span>
                                    <div>
                                        <input id="Yes" type="radio" value="Yes" name="driverAllocated"
                                            formControlName="driverAllocated" [ngClass]="{ 'is-invalid': submitted && f.driverAllocated.errors }">
                                        <label for="Yes">&nbsp;Yes</label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <input id="No" type="radio" value="No" name="driverAllocated"
                                            formControlName="driverAllocated" [ngClass]="{ 'is-invalid': submitted && f.driverAllocated.errors }">
                                        <label for="No">&nbsp;No</label>
                                        <div *ngIf="submitted && f.driverAllocated.errors" class="invalid-feedback">
                                            <div *ngIf="f.driverAllocated.errors.required">Driver Allocation is required</div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="form-group">
                                <label style="font-weight:bold">
                                   Manpower Allocated :
                                    <div>
                                        <input id="Yes" type="radio" value="Yes" name="manpowerAllocated"
                                            formControlName="manpowerAllocated" [ngClass]="{ 'is-invalid': submitted && f.manpowerAllocated.errors }">
                                        <label for="Yes">&nbsp;Yes</label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <input id="No" type="radio" value="No" name="manpowerAllocated"
                                            formControlName="manpowerAllocated" [ngClass]="{ 'is-invalid': submitted && f.manpowerAllocated.errors }">
                                        <label for="No">&nbsp;No</label>
                                        <div *ngIf="submitted && f.manpowerAllocated.errors" class="invalid-feedback">
                                            <div *ngIf="f.manpowerAllocated.errors.required">Driver Allocation is required</div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <br />

                            <div class="form-group"><input type="submit" *ngIf="!vehicleID" value="Submit" class="btn btn-primary"
                                    [disabled]="!addVehicleForm.valid">
                                    <input type="submit" *ngIf="vehicleID" value="Update" class="btn btn-primary"
                                    [disabled]="!addVehicleForm.valid"></div>
                        </form>
                    </div>
                    <div class="tab-pane" *ngIf="tab==2" [ngClass]="{active:tab==2}">
                        <section class="content-header">

                            <div class="container-fluid">
                                <div class="row mb-2">
                                    <div class="col-sm-6">
                                        <h5 class="card-header">Manpower Details</h5>
                                        <!-- <h1 class="m-0 text-dark">Manpower List</h1> -->
                                    </div>

                                </div>
                                <!-- /.row -->
                            </div>
                            <!-- /.container-fluid -->
                        </section>
                        <section class="content">
                            <!-- Default box -->
                            <div class="container-fluid">

                                <div class="card">

                                    <div class="card-body">

                                        <div class="container" *ngIf="isReadModeManpower">
                                            <div class=" row">
                                                <div class="col-12">
                                                    <p style="float:right">

                                                        <input type="button" (click)="createManpower()"
                                                             value="Add New User"
                                                            class="btn btn-link">
                                                    </p>
                                                </div>

                                            </div>

                                            <div class="row">
                                                <table class="table table-striped table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style="font-weight:bold">S. No.</th>
                                                            <th style="font-weight:bold">Vehicle No.</th>
                                                            <th style="font-weight:bold">User Name</th>
                                                            <th style="font-weight:bold">User Mobile</th>
                                                            <th style="font-weight:bold">User Email</th>
                                                             <th style="font-weight:bold">Type</th>
                                                            <th style="font-weight:bold">Designation</th>
                                                            <th style="font-weight:bold">Action</th>
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let userSample of manpowerData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                                            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                                            <td>{{userSample.vehicleNo}}</td>
                                                            <td>{{userSample.name}}</td>
                                                            <td>{{userSample.mobile}}</td>
                                                            <td>{{userSample.email}}</td>
                                                            <td>{{userSample.userType}}</td>
                                                            <td>{{userSample.designation}}</td>
                                                            <td>
                                                                <input type="button" (click)="updateManpower(userSample)"
                                                                     value="Edit"
                                                                    class="btn btn-primary">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <pagination-controls (pageChange)="p = $event" class="float-right">
                                                </pagination-controls>
                                            </div>

                                        </div>

                                        <div *ngIf="isWriteModeManpower" style="margin-left: 150px;">
                                            <div class="row">
                                                <div class="col-mod-12">


                                                    <form [formGroup]="adduserForm" (ngSubmit)="saveManpowerData()">
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Vehicle No. :<span style="color:red;">*</span>
                                                                <ng-select [items]="userRecordData" bindLabel="userId"
                                                                bindValue="userId" [(ngModel)]="selectedvehicle" formControlName="vehicleNo"
                                                                [disabled]="true" style="width:600px">
                                                            </ng-select>
                                                            <div *ngIf="submitted && adduserForm.controls.vehicleNo.errors" class="error">
                                                                <div *ngIf="adduserForm.controls.vehicleNo.errors.required"
                                                                    style="color:red">Vehicle No.
                                                                    is required</div>
                                                            </div>    

                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Designation :<span style="color:red;">*</span>
                                                                <input class="form-control" style="width:600px" formControlName="designation" placeholder="Enter required designation here" [ngClass]="{ 'is-invalid': submitted && u.designation.errors }">
                                                                <div *ngIf="submitted && u.designation.errors" class="invalid-feedback">
                                                                   <div *ngIf="u.designation.errors.required">Designation is required</div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="gender">User Type:<span style="color:red;">*</span></label>
                                                            <div>
                                                                <input id="Technical" type="radio" value="Technical"
                                                                    name="userType" formControlName="userType">
                                                                <label for="Technical">&nbsp;Technical</label>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input id="NonTechnical" type="radio"
                                                                    value="NonTechnical" name="userType"
                                                                    formControlName="userType">
                                                                <label for="NonTechnical">&nbsp;Non-Technical</label>
                                                            </div>
                                                           <div>

                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Name :<span style="color:red;">*</span>
                                                                <input type="text" style="width:600px"
                                                                formControlName="name"  placeholder="Enter required name here" class="form-control" [ngClass]="{ 'is-invalid': submitted && u.name.errors }">
                                                                <div *ngIf="submitted && u.name.errors" class="invalid-feedback">
                                                                   <div *ngIf="u.name.errors.required">name is required</div>
                                                               </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Email ID :<span style="color:red;">*</span>
                                                                <input class="form-control" type="email"
                                                                formControlName="email" style="width:600px" placeholder="Enter required emailid here"  [ngClass]="{ 'is-invalid': submitted && u.email.errors }" >
                                                                <div *ngIf="submitted && u.email.errors" class="invalid-feedback">
                                                                   <div *ngIf="u.email.errors.required">Email is required</div>
                                                               </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Mobile No. :<span style="color:red;">*</span>
                                                                <input class="form-control" placeholder="Enter required mobile number of 10 digits" formControlName="mobile" 
                                                                maxlength="10" numbers-only style="width:600px" [ngClass]="{ 'is-invalid': submitted && u.mobile.errors }">
                                                                <div *ngIf="submitted && u.mobile.errors" class="invalid-feedback">
                                                                   <div *ngIf="u.mobile.errors.required">Mobile No. is required</div>
                                                               </div>
                                                               <input type="hidden" class="form-control" formControlName="Id">
                                                            </label>
                                                        </div>
                                                        

                                                        <br />
                                <div class="form-group" style="text-align: center;"><input type="submit" value="Submit"
                                                                class="btn btn-primary" [disabled]="!adduserForm.valid" *ngIf="!manpowerID">
                                                                <input type="submit" value="Update"
                                                                class="btn btn-primary" [disabled]="!adduserForm.valid" *ngIf="manpowerID">
                                                                &nbsp;&nbsp;&nbsp;
                                                                <input type="submit" (click)="backManpowerList()"
                                                            value="Back" class="btn btn-primary">
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="tab-pane" *ngIf="tab==3" [ngClass]="{active:tab==3}">
                        <section class="content-header">

                            <div class="container-fluid">
                                <div class="row mb-2">
                                    <div class="col-sm-6">
                                        <!-- <h1 class="m-0 text-dark">Equipment List</h1> -->
                                        <h5 class="card-header">Equipment List</h5>
                                    </div>

                                </div>
                                <!-- /.row -->
                            </div>
                            <!-- /.container-fluid -->
                        </section>
                        <section class="content">
                            <!-- Default box -->
                            <div class="container-fluid">

                                <div class="card">

                                    <div class="card-body">

                                        <div class="container" *ngIf="isReadModeEquipmentList">
                                            <div class=" row">
                                                <div class="col-12">
                                                    <p style="float:right">

                                                        <input type="button" (click)="createEquipment()"
                                                            value="Add Equipment" class="btn btn-link">
                                                    </p>
                                                </div>

                                            </div>
                                            <div class="row">
                                                <table class="table table-striped table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style="font-weight:bold">S. No.</th>
                                                            <th style="font-weight:bold">Vehicle No.</th>
                                                            <th style="font-weight:bold">Equipment Type</th>
                                                            <th style="font-weight:bold">Equipment Name</th>
                                                            <th style="font-weight:bold">Installation Date</th>
                                                            <th style="font-weight:bold">Least Count</th>
                                                            <!-- <th style="font-weight:bold">Model</th> -->
                                                            <th style="font-weight:bold">Accuracy</th>
                                                            <th style="font-weight:bold">Action</th> 
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let equipSample of equipRecordData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                                            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                                            <td>{{equipSample.vehicleNo}}</td>
                                                            <td>{{equipSample.equipmentType}}</td>
                                                            <td>{{equipSample.equipmentName}}</td>
                                                            <td>{{equipSample.installationDate | date: 'dd-MM-yyyy'}}
                                                            </td>
                                                            <td>{{equipSample.leastCount}}</td>
                                                            <!-- <td>{{equipSample.model}}</td> -->
                                                            <td>{{equipSample.accuracy}}</td>
                                                             <td>
                                              <input type="button" (click)="deleteEquip(equipSample)"  value="Delete"
                                                class="btn btn-danger">
                                            </td> 
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <pagination-controls (pageChange)="p = $event" class="float-right">
                                                </pagination-controls>
                                            </div>

                                        </div>

                                        <div *ngIf="isWriteModeEquipmentList" style="margin-left: 150px;">
                                            <div class="row">
                                                <div class="col-mod-12">


                                                    <form [formGroup]="addEquipmentForm"
                                                        (ngSubmit)="saveEquipmentData()">
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Vehicle No. :<span style="color:red;">*</span>
                                                                <ng-select [items]="userRecordData" bindLabel="userId"
                                                            bindValue="userId" [(ngModel)]="selectedvehicle" formControlName="vehicleNo"
                                                            [disabled]="true" style="width:600px">
                                                        </ng-select>
                                                        <div *ngIf="submitted && addEquipmentForm.controls.vehicleNo.errors" class="error">
                                                            <div *ngIf="addEquipmentForm.controls.vehicleNo.errors.required"
                                                                style="color:red">Vehicle No.
                                                                is required</div>
                                                        </div>

                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="gender">Equipment Type:<span style="color:red;">*</span></label>
                                                            <div>
                                                                <input id="Chemical" type="radio" value="Chemical"
                                                                    name="equipmentType"
                                                                    formControlName="equipmentType">
                                                                <label for="chemical">&nbsp;Chemical</label>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input id="Microbiological" type="radio"
                                                                    value="Microbiological" name="equipmentType"
                                                                    formControlName="equipmentType">
                                                                <label
                                                                    for="Microbiological">&nbsp;Microbiological</label>
                                                            </div>
                                                            <div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Equipment Name :<span style="color:red;">*</span>
                                                                <select [(ngModel)]="selectedequipmentsCapabilities"
                                                                    style="width:600px" formControlName="equipmentId"
                                                                    class="form-control">
                                                                    <option [ngValue]="null" selected disabled>Select
                                                                        Equipment</option>
                                                                    <option *ngFor="let equipment of equipmentsData"
                                                                        [ngValue]="equipment.equipmentId">
                                                                        {{equipment.equipmentName}}</option>
                                                                </select>
                                                                <div *ngIf="submitted && addEquipmentForm.controls.equipmentId.errors" class="error">
                                                                    <div *ngIf="addEquipmentForm.controls.equipmentId.errors.required"
                                                                        style="color:red">Equipment
                                                                        is required</div>
                                                                </div>

                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Installation Date :<span style="color:red;">*</span>
                                                                <input [(ngModel)]="InstallationDate"
                                                                    class="form-control" type="date"
                                                                    formControlName="installationDate" style="width:600px" [ngClass]="{ 'is-invalid': submitted && e.installationDate.errors }">
                                                                    <div *ngIf="submitted && e.installationDate.errors" class="invalid-feedback">
                                                                       <div *ngIf="e.installationDate.errors.required">Installation Date is required</div>
                                                                   </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Least Count :<span style="color:red;">*</span>
                                                                <input type="text" style="width:600px"
                                                                    formControlName="leastCount" class="form-control" placeholder="Enter required Least Count here" [ngClass]="{ 'is-invalid': submitted && e.leastCount.errors }">
                                                                    <div *ngIf="submitted && e.leastCount.errors" class="invalid-feedback">
                                                                       <div *ngIf="e.leastCount.errors.required">Least Count is required</div>
                                                                   </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Model :<span style="color:red;">*</span>
                                                                <input type="text" style="width:600px"
                                                                    formControlName="model" class="form-control" [ngClass]="{ 'is-invalid': submitted && e.model.errors }" placeholder="Enter required model here">
                                                                    <div *ngIf="submitted && e.model.errors" class="invalid-feedback">
                                                                       <div *ngIf="e.model.errors.required">Model is required</div>
                                                                   </div>
                                                            </label>
                                                        </div>
                                                        <div class="form-group">
                                                            <label style="font-weight:bold">
                                                                Accuracy :<span style="color:red;">*</span>
                                                                <input type="text" style="width:600px"  placeholder="Enter required accuracy here"
                                                                formControlName="accuracy" class="form-control" [ngClass]="{ 'is-invalid': submitted && e.accuracy.errors }">
                                                                <div *ngIf="submitted && e.accuracy.errors" class="invalid-feedback">
                                                                   <div *ngIf="e.accuracy.errors.required">Accuracy is required</div>
                                                               </div>
                                                            </label>
                                                        </div>
                                                        <br />

                                                        <div class="form-group" style="text-align: center;"><input
                                                                type="submit" value="Submit" class="btn btn-primary"
                                                                [disabled]="!addEquipmentForm.valid">&nbsp;&nbsp;&nbsp;
                                                            <input type="submit" (click)="backEquipmentList()"
                                                                value="Back" class="btn btn-primary">
                                                        </div>

                                                       
                                                    </form>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="tab-pane" *ngIf="tab==4" [ngClass]="{active:tab==4}">
                        <section class="content-header">

                            <div class="container-fluid">
                                <div class="row mb-2">
                                    <div class="col-sm-6">
                                        <!-- <h1 class="m-0 text-dark">Test Capability List</h1> -->
                                        <h5 class="card-header">Test Capability</h5>
                                    </div>

                                </div>
                                <!-- /.row -->
                            </div>
                            <!-- /.container-fluid -->
                        </section>
                        <section class="content">
                            <!-- Default box -->
                            <div class="container-fluid">

                                <div class="card">

                                    <div class="card-body">

                                        <div class="container" *ngIf="isReadModeTestingCapability">
                                            <div class=" row">
                                                <div class="col-12">
                                                    <p style="float:right">

                                                        <input type="button" (click)="createTestingCapability()"
                                                            value="Add / Update Testing Capability"
                                                            class="btn btn-link">
                                                    </p>
                                                </div>

                                            </div>
                                         <div class="row">
                                                <table class="table table-striped table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style="font-weight:bold">S. No.</th>
                                                            <th style="font-weight:bold">Vehicle No.</th>
                                                            <th style="font-weight:bold">Product Name</th>
                                                            <th style="font-weight:bold">Parameter Count</th>
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let testingSample of testingRecordData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                                            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                                            <td>{{testingSample.vehicleNo}}</td>
                                                            <td>{{testingSample.productName}}</td>
                                                            <td>{{testingSample.paramCount}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <pagination-controls (pageChange)="p = $event" class="float-right">
                                                </pagination-controls>
                                            </div>


                                        </div>

                                        <div *ngIf="isWriteModeTestingCapability">
                                            <div class="container-fluid">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h3 class="card-title">Add New Testing</h3>

                                                    </div>
                                                    <div class="card-body">
                                                        Vehicle No. :
                                                        <ng-select [items]="userRecordData" bindLabel="userId"
                                                            bindValue="userId" [(ngModel)]="selectedvehicle"
                                                            [disabled]="true">
                                                        </ng-select>

                                                        Select Product: <ng-select [items]="products"
                                                            bindLabel="productName" autofocus bindValue="productId"
                                                            [(ngModel)]="selectedproductId" (change)="productChanged()"
                                                            [disabled]="!selectedvehicle" autofocus>
                                                            <ng-option [value]="null">Select Product</ng-option>
                                                        </ng-select>
                                                        <div *ngIf="selectedproductId!=undefined">

                                                            <br /><b>Selected Product: {{selectedProdctName}}</b>



                                                            <table
                                                                class="table table-striped table-hover table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <td style="font-weight:bold">Parameter</td>
                                                                        <td style="font-weight:bold">Availability</td>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr *ngFor="let parameter of parameters">
                                                                        <td>{{ parameter.testParam }}</td>
                                                                        <td> <input type="checkbox"
                                                                                [(ngModel)]="parameter.result"
                                                                                id="{{parameter.mappingId}}"
                                                                                name="{{parameter.mappingId}}" />
                                                                        </td>

                                                                    </tr>

                                                                </tbody>
                                                            </table>
                                                            <br />
                                                            <div class="form-group" style="text-align: center;"><input
                                                                    type="submit" (click)="saveTestingCapabilityData()"
                                                                    value="Submit"
                                                                    class="btn btn-primary">&nbsp;&nbsp;&nbsp;
                                                                <input type="submit"
                                                                    (click)="backTestingCapabilityList()" value="Back"
                                                                    class="btn btn-primary">
                                                            </div>

                                                        </div>


                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <!--tab end-->

            </div>
        </div>

    </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>